function menu() {
    $('.menu').click(function () {
        $('.navbar .container .row').css('top', $('header').outerHeight());
        $('.navbar .submenu').css('max-height', 'calc(100vh - ' + $('header').outerHeight() + 'px)');
        if (!$('html').hasClass('menu-open')) {
            $('html').addClass('menu-open');
            bd.show()
        } else {
            $('html').removeClass('menu-open');
            bd.hide();
        }
    });

    $('.navbar li').each(function (i, v) {
        if ($(v).find('.submenu').length) {
            $(v).addClass('has-child');
        }
    });

    $('.js-show-userpanel').click(function () {
        if (!$(this).find('.subpanel').hasClass('sys')) {
            hidePanels();
            bd.show()
            $(this).find('.subpanel').addClass('sys');
        }
    });

    $('body').on('click', '.has-child', function () {
        if (!$(this).find('.submenu').hasClass('sys')) {
            $('.header .submenu').removeClass('sys');
            $(this).find('.submenu').addClass('sys');
            if (WW >= 991) {
                bd.show()
            } else {
                bd.show()
            }
        } else {
            $('.header .submenu').removeClass('sys');
            if (WW >= 991) {
                bd.hide();
            }
        }
    });
}

function forms() {
    const selects = document.querySelectorAll('.form-group .form-select');

    selects.forEach(select => {
        if (select.value === '') {
            select.classList.add('is-empty');
        }

        select.addEventListener('change', function () {
            this.classList.toggle('is-empty', this.value === '');
        });
    });

    const textareas = document.querySelectorAll(".form-textarea");

    textareas.forEach((textarea) => {
        if (textarea.value.trim() === "") {
            textarea.classList.add("is-empty");
        }

        textarea.addEventListener("focusout", function () {
            if (textarea.value.trim() === "") {
                textarea.classList.add("is-empty");
            } else {
                textarea.classList.remove("is-empty");
            }
        });
    });
}

function sliderRecomm() {
    $('.slider-recomm').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000
    }).on('swipe', function (event, slick, direction) {
        //  $('.slider-recomm').slick('slickPause');
    });

    $('.slider-recomm .slick-dots').on('click', function () {
        //   $('.slider-recomm').slick('slickPause');
    });
}

function sliderCategories() {
    $('.slider-categories').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2580,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.1,
                    arrows: false,
                }
            }
        ]
    });
}

function sliderProducts() {
    $('.slider-products').on('init', function () {
        resizeBoxes('.product-list', '.product-title');
    }).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

function sliderSeries() {
    $('.slider-series').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    });
}

function sliderSeriesProducts() {
    $('.slider-so').on('init', function () {
        resizeBoxes('.slider-so', '.so-title');
    }).slick({
        slidesToShow: 1.1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.1
                }
            }
        ]
    });
}

function slideIconCategories() {
    var autoplaySpeed = $('.slider-iconcategories').data('autoplayspeed');

    $('.slider-iconcategories').on('init', function () {
        $('.slider-iconcategories').addClass('sys');
    }).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: false,
        autoplaySpeed: autoplaySpeed,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    arrows: false,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    autoplay: true,
                    slidesToShow: 2.2,
                    arrows: false,
                }
            }
        ]
    });
}

function sliderSeriesPageV2() {
    $('.ss-items').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            },
        ]
    });
}

function cartLayer() {
    var docHeight = $(window).height();

    $('.cart').height(docHeight);

    $('.js-show-cart').click(function () {
        showCartLayer();
    });
}

function basketSum() {
    var sum = 0;
    $('.cart .qty-input').each(function () {
        sum += Number($(this).val());
    });

    $('.cart-counter').text(sum);

    $('body').on('keydown', function (e) {
        if ($('.cart').hasClass('sys') && $('.cart').hasClass('cart-error')) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
            }
        }
    });
}

function showCartLayer(statement) {
    hidePanels();

    if (statement == true) {
        $('.cart').addClass('easy-sys');
    } else {
        $('.cart').addClass('sys');
    }

    if (statement != true) {
        bd.show();
    }
}

function prodListPage() {
    $('.js-showcategories').click(function () {
        if (!$('.pl-mobilcat').hasClass('sys')) {
            $('.pl-mobilcat').addClass('sys').slideDown();
        } else {
            $('.pl-mobilcat').removeClass('sys').slideUp();
        }
    });

    if ($('.pl-mobilcat').empty()) {
        $('.product-category-item.active').clone().appendTo('.pl-mobilcat');
    }

}

function productPage() {
    $('.pp-image').addClass('sys');
    /*if ($('.pp-image img').length >= 2) {
        $('.pp-image').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
        });
    } else {
        $('.pp-image').addClass('sys');
    }*/

    $('.slider-pg').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        centerPadding: 0,
        asNavFor: '.slider-pgnav'
    });
    $('.slider-pgnav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-pg',
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false
                }
            }
        ]
    });
}

function collapsableBox() {
    $('.pp-data-header').click(function () {
        if (!$(this).parent().hasClass('sys')) {
            if (!$(this).parent().hasClass('sys-onload')) {
                $('.pp-data-content').slideUp();
                $('.pp-data').removeClass('sys');

                $(this).parent().find('.pp-data-content').slideDown();
                $(this).parent().addClass('sys');
            } else {
                $(this).parent().find('.pp-data-content').slideUp(function () {
                    $(this).parent().removeClass('sys sys-onload');
                });
            }
        } else {
            $(this).parent().find('.pp-data-content').slideUp(function () {
                $(this).parent().removeClass('sys');
            });
        }
    });
}

function hidePanels() {
    bd.hide();
    $('.subpanel, .search').removeClass('sys');
    $('.popup').removeClass('active');
}

function backdrop() {
    $('.backdrop, .popup-dismiss, .cart-close').click(function () {
        $('body').removeClass('body-noscroll');
        $('.popup').removeClass('sys active');
        bd.fadeOut(function () {
            $(this).removeClass('transparent');
        });

        cartLayerVisible = false;

        if ($('html').hasClass('menu-open')) {
            $('html').removeClass('menu-open');
            $('.navbar-right').removeClass('sys');
        }

        if ($('.cart').hasClass('sys') || $('.cart').hasClass('easy-sys')) {
            $('.cart').removeClass('sys easy-sys');
        }

        if ($('.subpanel').hasClass('sys')) {
            $('.subpanel').removeClass('sys');
        }

        if ($('.search').hasClass('sys')) {
            $('.search').removeClass('sys')
        }

        if ($('.submenu').hasClass('sys')) {
            $('.submenu').removeClass('sys');
        }

        if ($('.product-category-ctn').hasClass('sys')) {
            $('.product-category-ctn').removeClass('sys');
        }
        if ($('.search').hasClass('sys')) {
            $('.search-item').attr('aria-selected', 'false');
            $('.search').removeClass('sys');
        }
    });
}

function popup() {
    $(doc).on('click', '.show-popup', function () {
        var target = $(this).data('target');

        $('.popup').removeClass('active');
        $('.popup-' + target).addClass('active');

        if ($('.subpanel').hasClass('sys')) {
            $('.subpanel').removeClass('sys')
        }

        if ($('.cart').hasClass('sys') || $('.cart').hasClass('easy-sys')) {
            $('.cart').removeClass('sys easy-sys');
        }

        bd.show()

    }).on('click', '.popup-close, .popup-dismiss, .popup-btnclose', function () {
        bd.hide();
        $('.popup').removeClass('active');
        setTimeout(function () {
            bd.removeClass('sys');
        }, 400);
    });
}

function showPopup(target) {
    handleFocusTrap('.asd', 'popup-' + target);
    handleEscapeClose();

    var windowHeight = $(window).height();

    if ($('.cart').hasClass('sys')) {
        $('.cart').removeClass('sys');
    }

    $('.popup').removeClass('active');
    $('.popup-' + target).addClass('active');

    bd.show()
}

function createPopup(title, text, button) {
    $('body').append('<div class="tr popup popup-custom"> ' + '<div class="popup-inner">' + '<div class="popup-close"><img src="../public/img/icons/black/close.svg" width="15" height="15" alt="" title=""/></div>' +

        '<div class="popup-content"><h2 class="h3 popup-title">' + title + '</h2> ' + '<p>' + text + '</p> ' + '<div class="popup-buttons"><button type="button" class="btn btn-blue popup-dismiss" title="' + button + '"><span>' + button + '</span></button></div>' + '</div> ' + '</div>');

    showPopup('custom');

}

function createNotification(text, type, source) {
    if (type == '') {
        type = 'success';
    }

    $('body').append('<div class="tr notification notification-' + type + '"><p class="h3 text-center text-uppercase">' + text + '</p>' + '</div>');

    setTimeout(function () {
        $('.notification').addClass('sys');
        if (source) {
            $(source).addClass('disable');
        }
    }, 100);
    setTimeout(function () {
        $('.notification').removeClass('sys').delay(400).queue(function () {
            $(this).remove();
            if (source) {
                $(source).removeClass('disable');
            }
        });
    }, 3000);
}

function notification() {
    $('body').on('click', '.create-notification', function () {
        var text = $(this).data('text'),
            type = $(this).data('type');

        createNotification(text, type, this);
    });
}

function tooltip() {
    $('.show-tooltip').click(function (e) {
        e.preventDefault();

        var $this = $(this),
            varText = $this.data('text');

        $('html').append($('<div class="tooltip"/>')
            .append($('<div class="tooltip-inner"/>')
                .append($('<div class="tooltip-content"/>')
                    .html(varText))
            )
        ).append($('<div class="backdrop-light sys"></div>'));


        var varTextHeight = $('.tooltip').not('.tooltip-sys').height();

        setTimeout(function () {
            $('.tooltip').not('.tooltip-sys').css({
                'top': $this.offset().top - (varTextHeight + 10),
                'left': $this.offset().left - ($('.tooltip').not('.tooltip-sys').width() / 2) + ($this.width() / 2),
                'z-index': '1003'
            });
        }, 100);
    });
}

function resizeBoxes(source, boxes) {
    if ($.type(source) === 'string') source = $(source);

    source.each(function () {
        var $thisRow = $(this);
        var maxHeight = 0;

        $thisRow.find(boxes).height('auto');

        $thisRow.find(boxes).each(function () {
            var height = $(this).height();
            if (height > maxHeight) maxHeight = height;
        });

        $thisRow.find(boxes).height(maxHeight);
    });
}

function getOS() {
    var a = '';
    var osString = {
        'windows': /(Win)/,
        'android': /Android/,
        'linux': /(Linux|X11)/,
        'ios': /(iPhone|iPad|iPod|Mac)/,
        'unix': /UNIX/,
        'bot': /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    };

    $.each(osString, function (k, v) {
        if (a == '' && v.test(navigator.userAgent)) a = k;
    });
    return a;
}

function getBrowser() {
    var a = '';
    var browserString = {
        'Chrome': 'chrome',
        'MSIE': 'ie',
        'Trident/': 'ie',
        'Firefox': 'ff',
        'Safari': 'safari',
        'Presto': 'opera',
        'Opera': 'opera'
    };
    $.each(browserString, function (k, v) {
        if (a == '' && navigator.userAgent.indexOf(k) != '-1') a = v;
    });
    return a;

}

/* apple-safari mobile rotation bug fixed */
if (os == 'ios' && browser == 'safari') {
    (function (doc) {
        var addEvent = 'addEventListener',
            type = 'gesturestart',
            qsa = 'querySelectorAll',
            scales = [1, 1],
            meta = qsa in doc ? doc[qsa]('meta[name=viewport]') : [];

        function fix() {
            meta.content = 'width=device-width,minimum-scale=' + scales[0] + ',maximum-scale=' + scales[1];
            doc.removeEventListener(type, fix, true);
        }

        if ((meta = meta[meta.length - 1]) && addEvent in doc) {
            fix();
            scales = [.25, 1.6];
            doc[addEvent](type, fix, true);
        }
    }(document));
}